import type {
  BookingChannel,
  BookingCoverageKind,
  BookingEventFilterStatus,
  BookingKind,
  BookingPaymentStatus,
  BookingReservationStatus,
} from '@/types/api/queries';

export const BOOKING_STATUS_LABEL_KEYS: Record<
  BookingReservationStatus,
  string
> = {
  pending_payment: 'status_pending_payment',
  reserved: 'status_reserved',
  attended: 'status_attended',
  missed: 'status_missed',
  cancelled: 'status_cancelled',
  expired: 'status_expired',
};

export const BOOKING_PAYMENT_LABEL_KEYS: Record<BookingPaymentStatus, string> =
  {
    paid: 'payment_paid',
    pending: 'payment_pending',
    none: 'payment_none',
  };

export const BOOKING_COVERAGE_LABEL_KEYS: Record<BookingCoverageKind, string> =
  {
    card: 'coverage_card',
    discount_card: 'coverage_discount_card',
    owned: 'coverage_owned',
    booking_purchase: 'coverage_booking_purchase',
    none: 'coverage_none',
  };

export const BOOKING_CHANNEL_LABEL_KEYS: Record<BookingChannel, string> = {
  admin: 'channel_admin',
  online_web: 'channel_online_web',
  online_mobile: 'channel_online_mobile',
};

export const BOOKING_KIND_LABEL_KEYS: Record<BookingKind, string> = {
  personal: 'kind_personal',
  group: 'kind_group',
  event: 'kind_event',
};

// A finished event has no stored status of its own — `completed` is derived from its end time,
// which is why it is a filter value and a badge but never a row's `status`.
export const BOOKING_EVENT_STATUS_LABEL_KEYS: Record<
  BookingEventFilterStatus,
  string
> = {
  scheduled: 'event_scheduled',
  completed: 'event_completed',
  cancelled: 'event_cancelled',
};

export const BOOKING_STATUS_BADGE_VARIANTS: Record<
  BookingReservationStatus,
  'default' | 'secondary' | 'destructive' | 'outline'
> = {
  pending_payment: 'outline',
  reserved: 'secondary',
  attended: 'default',
  missed: 'destructive',
  cancelled: 'destructive',
  expired: 'outline',
};

export const BOOKING_PAYMENT_STRIPE_CLASSES: Record<
  BookingPaymentStatus,
  string | null
> = {
  paid: 'bg-green-600',
  pending: 'bg-blue-600',
  none: null,
};

export const BOOKING_CLOSED_STATUSES: BookingReservationStatus[] = [
  'attended',
  'missed',
  'cancelled',
  'expired',
];

export const GROUP_WEEKDAYS = [1, 2, 3, 4, 5, 6, 0] as const;

export const GROUP_WEEKDAY_KEYS = [
  'weekday short: sunday',
  'weekday short: monday',
  'weekday short: tuesday',
  'weekday short: wednesday',
  'weekday short: thursday',
  'weekday short: friday',
  'weekday short: saturday',
] as const;

export const GROUP_DURATION_MINUTES = [
  30, 60, 90, 120, 150, 180, 210, 240,
] as const;
